export default {
  MuiMenu: {
    paper: {
      maxHeight: 400,
    },
  },
};
